import { render } from "./Parcel.vue?vue&type=template&id=47a19aa1&scoped=true"
import script from "./Parcel.vue?vue&type=script&lang=js"
export * from "./Parcel.vue?vue&type=script&lang=js"

import "./Parcel.vue?vue&type=style&index=0&id=47a19aa1&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a19aa1"]])

export default __exports__